var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgZoomOut = function SvgZoomOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.781 17.629c.274.273.274.683 0 .93a.544.544 0 0 1-.437.191c-.192 0-.356-.055-.465-.191l-3.664-3.665a5.59 5.59 0 0 1-3.527 1.231A5.683 5.683 0 0 1 5 10.437C5 7.32 7.543 4.75 10.688 4.75c3.117 0 5.687 2.57 5.687 5.688 0 1.34-.465 2.57-1.258 3.527l3.664 3.664Zm-8.093-2.817a4.37 4.37 0 0 0 4.374-4.374 4.388 4.388 0 0 0-4.374-4.376 4.37 4.37 0 0 0-4.376 4.375 4.353 4.353 0 0 0 4.375 4.376Zm2.187-5.03c.355 0 .656.3.656.655 0 .383-.3.657-.683.657H8.473c-.356 0-.63-.274-.63-.656 0-.356.274-.657.63-.657h4.402Z"
  })));
};

export default SvgZoomOut;